// CountdownOverlay.jsx
import React, { useState, useEffect } from "react";
import "./CountdownOverlay.css";

const CountdownOverlay = ({ onComplete }) => {
  const [count, setCount] = useState(3);

  useEffect(() => {
    if (count > 0) {
      const timer = setTimeout(() => setCount(count - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      if (onComplete) onComplete();
    }
  }, [count, onComplete]);

  return (
    <div className="countdown-overlay">
      <div className="going-live">Going Live in... </div>
      {count > 0 && <div className="countdown-number">{count}</div>}
      <div className="edge-pulse" />
    </div>
  );
};

export default CountdownOverlay;
